import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import ManageAboutUs from './pages/ManageAboutUs';
import ManageCoas from './pages/ManageCOAPage';
import ProtectedRoute from './components/ProtectedRoute';
import TestResults from './pages/TestResults';
import AgeVerificationModal from './components/AgeVerificationModal';
import ContactUs from './pages/ContactUs';
import AdminContacts from './pages/AdminContacts';
import Blog from './pages/Blog';
import BlogPostPage from './pages/BlogPostPage';
import ManageBlog from './pages/ManageBlog';
import ManageQuotes from './pages/ManageQuotes';
import InviteAdmin from './pages/InviteAdmin';
import Register from './pages/Register';
import { ParallaxProvider } from 'react-scroll-parallax';
import React, { useEffect, useState } from 'react';
import CreateUpdate from './pages/CreateUpdate';
import ErrorBoundary from './components/ErrorBoundary';
import ManageProducts from './pages/ManageProducts';
import ManageAdmin from './pages/ManageAdmin';
import ManageSubscribers from './pages/ManageSubscribers';
import ManageLists from './pages/ManageLists'; 



function App() {
  const [isVerified, setIsVerified] = useState<boolean>(false);

  // Check if the user has verified their age before
  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    if (ageVerified === 'true') {
      setIsVerified(true);
    }
  }, []);

  const handleVerify = () => {
    setIsVerified(true);
  };

  // If user is not verified, show the AgeVerificationModal
  if (!isVerified) {
    return <AgeVerificationModal onVerify={handleVerify} />;
  }

  // Render the rest of the application if age is verified
  return (
    <ParallaxProvider>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/test-results" element={<TestResults />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/register" element={<Register />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />

          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/admin/manage-about-us" element={<ProtectedRoute><ManageAboutUs /></ProtectedRoute>} />
          <Route path="/admin/manage-coa" element={<ProtectedRoute><ManageCoas /></ProtectedRoute>} />
          <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
          <Route path="/admin/manage-blog" element={<ProtectedRoute><ManageBlog /></ProtectedRoute>} />
          <Route path="/admin/manage-quotes" element={<ProtectedRoute><ManageQuotes /></ProtectedRoute>} />
          <Route path="/admin/manage-admin" element={<ProtectedRoute><ManageAdmin /></ProtectedRoute>} />
          <Route path="/admin/manage-subscribers" element={<ProtectedRoute><ManageSubscribers /></ProtectedRoute>} />
          <Route path="/admin/invite-admin" element={<ProtectedRoute><InviteAdmin /></ProtectedRoute>} />
          <Route path="/admin/create-update" element={<ProtectedRoute><CreateUpdate /></ProtectedRoute>} />
           <Route path="/admin/manage-lists" element={<ManageLists />} />
           <Route path="/admin/manage-products" element={<ManageProducts />} />
        </Routes>
      </ErrorBoundary>
    </ParallaxProvider>
  );
}
export default App;
